import { Checkbox } from '@mui/material';
import { DataCellProps } from '../types';

export const MembersV2CheckboxCell = ({ member, _customRowProps }: DataCellProps) => {
  const { selectedIds, onToggleRow } = _customRowProps;
  const checked = selectedIds.has(member.id);
  return (
    <Checkbox
      checked={checked}
      onClick={(e) => {
        e.stopPropagation();
        onToggleRow(member.id);
      }}
    />
  );
};

export default MembersV2CheckboxCell;
